'use client';

import React, { useEffect, useRef } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const featuredNews = {
  title: 'Admissions Open for D.Pharm & B.Pharm 2026–27',
  category: 'Featured',
  date: '18 July 2026',
  image: '/assets/images/abt-img.png',
  description:
    'Applications are now open for aspiring pharmacy professionals. Experience industry-oriented education, advanced laboratories, experienced faculty and holistic development at Shri R. P. College of Pharmacy.',
};
const news = [
  {
    id: 1,
    category: 'Admission',
    title: 'Admissions Open for D.Pharm & B.Pharm 2026–27',
    date: '18 Jul',
    description:
      'Applications are now open for aspiring pharmacy professionals. Submit your application before the deadline.',
  },
  {
    id: 2,
    category: 'Event',
    title: 'Industrial Visit to Pharmaceutical Manufacturing Unit',
    date: '15 Jul',
    description:
      'Second-year students participated in an industrial visit to gain practical exposure.',
  },
  {
    id: 3,
    category: 'Achievement',
    title: 'Students Participate in National Pharmacy Seminar',
    date: '12 Jul',
    description:
      'Students presented research papers and represented the college at a national-level seminar.',
  },
  {
    id: 4,
    category: 'Notice',
    title: 'Scholarship Applications Invited',
    date: '10 Jul',
    description:
      'Eligible students can now apply for various state and institutional scholarships.',
  },
];
const updates = [
  {
    id: 1,
    type: 'Circular',
    title: 'Academic Calendar Released for Session 2026–27',
    date: '18 Jul',
    icon: 'DocumentTextIcon',
  },
  {
    id: 2,
    type: 'Admission',
    title: 'Admissions Open for D.Pharm & B.Pharm',
    date: '15 Jul',
    icon: 'AcademicCapIcon',
  },
  {
    id: 3,
    type: 'Event',
    title: 'Industrial Visit to Pharmaceutical Manufacturing Unit',
    date: '12 Jul',
    icon: 'BuildingOffice2Icon',
  },
  {
    id: 4,
    type: 'Notice',
    title: 'Scholarship Applications Invited',
    date: '10 Jul',
    icon: 'BellAlertIcon',
  },
  {
    id: 5,
    type: 'News',
    title: 'Students Participate in National Pharmacy Seminar',
    date: '08 Jul',
    icon: 'NewspaperIcon',
  },
  {
    id: 6,
    type: 'Placement',
    title: 'Campus Placement Drive Scheduled Next Month',
    date: '04 Jul',
    icon: 'BriefcaseIcon',
  },
];

export default function InstitutionUpdates() {
  const sectionRef = useRef<HTMLElement>(null);
  const leftRef = useRef<HTMLDivElement>(null);
  const rightRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          leftRef.current?.classList.add('revealed');

          if (leftRef.current) {
            leftRef.current.style.opacity = '1';
            leftRef.current.style.transform = 'translateY(0)';
          }

          if (rightRef.current) {
            rightRef.current.style.opacity = '1';
            rightRef.current.style.transform = 'translateY(0)';
          }

          observer.disconnect();
        });
      },
      {
        threshold: 0.2,
      }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section data-component-id="src/app/components/InstitutionUpdates.tsx:132:4" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="132" data-component-end-line="404" data-component-file="InstitutionUpdates.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-24%20md%3Apy-28%20px-6%20max-w-7xl%20mx-auto%22%7D"
      ref={sectionRef}
      className="py-24 md:py-28 px-6 max-w-7xl mx-auto"
    >
      {/* Heading */}

      <div data-component-id="src/app/components/InstitutionUpdates.tsx:138:6" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="138" data-component-end-line="157" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-3xl%20mb-14%22%7D" className="max-w-3xl mb-14">

        <span data-component-id="src/app/components/InstitutionUpdates.tsx:140:8" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="140" data-component-end-line="142" data-component-file="InstitutionUpdates.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22section-label%20block%20mb-4%22%2C%22textContent%22%3A%22Institution%20Updates%22%7D" className="section-label block mb-4">
          Institution Updates
        </span>

        <h2 data-component-id="src/app/components/InstitutionUpdates.tsx:144:8" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="144" data-component-end-line="149" data-component-file="InstitutionUpdates.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-display%20mb-6%22%2C%22textContent%22%3A%22Stay%20Updated%20with%20Our%22%7D" className="text-display mb-6">
          Stay Updated with Our{' '}
          <em data-component-id="src/app/components/InstitutionUpdates.tsx:146:10" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="146" data-component-end-line="148" data-component-file="InstitutionUpdates.tsx" data-component-name="em" data-component-content="%7B%22elementName%22%3A%22em%22%2C%22className%22%3A%22font-normal%20italic%20text-primary%22%2C%22textContent%22%3A%22Latest%20News%22%7D" className="font-normal italic text-primary">
            Latest News
          </em>
        </h2>

        <p data-component-id="src/app/components/InstitutionUpdates.tsx:151:8" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="151" data-component-end-line="155" data-component-file="InstitutionUpdates.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%20leading-relaxed%20text-lg%22%2C%22textContent%22%3A%22Explore%20the%20latest%20announcements%2C%20academic%20circulars%2C%5Cn%20%20%20%20%20%20%20%20%20%20admission%20notifications%2C%20events%20and%20achievements%20from%5Cn%20%20%20%20%20%20%20%20%20%20Shri%20R.%20P.%20College%20of%20Pharmacy.%22%7D" className="text-muted-foreground leading-relaxed text-lg">
          Explore the latest announcements, academic circulars,
          admission notifications, events and achievements from
          Shri R. P. College of Pharmacy.
        </p>

      </div>

      {/* Main Grid */}

      <div data-component-id="src/app/components/InstitutionUpdates.tsx:161:6" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="161" data-component-end-line="356" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-12%20gap-10%22%7D" className="grid grid-cols-1 lg:grid-cols-12 gap-10">

        {/* Featured News */}

        <div data-component-id="src/app/components/InstitutionUpdates.tsx:165:8" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="165" data-component-end-line="228" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-7%22%7D"
  ref={leftRef}
  className="lg:col-span-7"
  style={{
    opacity: 0,
    transform: 'translateY(40px)',
    transition:
      'opacity 1s cubic-bezier(0.16,1,0.3,1), transform 1s cubic-bezier(0.16,1,0.3,1)',
  }}
>
  <div data-component-id="src/app/components/InstitutionUpdates.tsx:175:2" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="175" data-component-end-line="227" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22glass-card%20rounded-3xl%20border%20border-border%20overflow-hidden%20shadow-float%22%7D" className="glass-card rounded-3xl border border-border overflow-hidden shadow-float">

    <div data-component-id="src/app/components/InstitutionUpdates.tsx:177:4" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="177" data-component-end-line="184" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22px-7%20py-6%20border-b%20border-border%22%7D" className="px-7 py-6 border-b border-border">
      <h3 data-component-id="src/app/components/InstitutionUpdates.tsx:178:6" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="178" data-component-end-line="180" data-component-file="InstitutionUpdates.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-xl%20font-semibold%22%2C%22textContent%22%3A%22Latest%20News%22%7D" className="text-xl font-semibold">
        Latest News
      </h3>
      <p data-component-id="src/app/components/InstitutionUpdates.tsx:181:6" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="181" data-component-end-line="183" data-component-file="InstitutionUpdates.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%20mt-1%22%2C%22textContent%22%3A%22College%20News%20%26%20Announcements%22%7D" className="text-sm text-muted-foreground mt-1">
        College News & Announcements
      </p>
    </div>

    <div data-component-id="src/app/components/InstitutionUpdates.tsx:186:4" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="186" data-component-end-line="212" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
      {news.map((item) => (
        <Link data-component-id="src/app/components/InstitutionUpdates.tsx:188:8" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="188" data-component-end-line="210" data-component-file="InstitutionUpdates.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fnews%22%2C%22className%22%3A%22group%20block%20px-7%20py-6%20border-b%20border-border%20last%3Aborder-b-0%20hover%3Abg-secondary%2F5%20transition-colors%20duration-300%22%7D"
          key={item.id}
          href="/news"
          className="group block px-7 py-6 border-b border-border last:border-b-0 hover:bg-secondary/5 transition-colors duration-300"
        >
          <div data-component-id="src/app/components/InstitutionUpdates.tsx:193:10" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="193" data-component-end-line="201" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20mb-3%22%7D" className="flex items-center justify-between mb-3">
            <span data-component-id="src/app/components/InstitutionUpdates.tsx:194:12" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="194" data-component-end-line="196" data-component-file="InstitutionUpdates.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22rounded-full%20bg-secondary%2F10%20px-3%20py-1%20text-xs%20font-semibold%20text-secondary%22%7D" className="rounded-full bg-secondary/10 px-3 py-1 text-xs font-semibold text-secondary">
              {item.category}
            </span>

            <span data-component-id="src/app/components/InstitutionUpdates.tsx:198:12" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="198" data-component-end-line="200" data-component-file="InstitutionUpdates.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%7D" className="text-sm text-muted-foreground">
              {item.date}
            </span>
          </div>

          <h3 data-component-id="src/app/components/InstitutionUpdates.tsx:203:10" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="203" data-component-end-line="205" data-component-file="InstitutionUpdates.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-xl%20font-semibold%20mb-3%20group-hover%3Atext-primary%20transition-colors%22%7D" className="text-xl font-semibold mb-3 group-hover:text-primary transition-colors">
            {item.title}
          </h3>

          <p data-component-id="src/app/components/InstitutionUpdates.tsx:207:10" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="207" data-component-end-line="209" data-component-file="InstitutionUpdates.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%20leading-relaxed%20line-clamp-2%22%7D" className="text-muted-foreground leading-relaxed line-clamp-2">
            {item.description}
          </p>
        </Link>
      ))}
    </div>

    <div data-component-id="src/app/components/InstitutionUpdates.tsx:214:4" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="214" data-component-end-line="225" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22px-7%20py-6%20bg-muted%2F20%22%7D" className="px-7 py-6 bg-muted/20">
      <Link data-component-id="src/app/components/InstitutionUpdates.tsx:215:6" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="215" data-component-end-line="224" data-component-file="InstitutionUpdates.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fnews%22%2C%22className%22%3A%22btn-outline%20w-full%20justify-center%22%2C%22textContent%22%3A%22View%20All%20News%22%7D"
        href="/news"
        className="btn-outline w-full justify-center"
      >
        View All News
        <Icon data-component-id="src/app/components/InstitutionUpdates.tsx:220:8" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="220" data-component-end-line="223" data-component-file="InstitutionUpdates.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowRightIcon%22%7D"
          name="ArrowRightIcon"
          size={16}
        />
      </Link>
    </div>

  </div>
</div>    
        {/* Latest Updates */}

        <div data-component-id="src/app/components/InstitutionUpdates.tsx:231:8" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="231" data-component-end-line="354" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-5%22%7D"
          ref={rightRef}
          className="lg:col-span-5"
          style={{
            opacity: 0,
            transform: 'translateY(40px)',
            transition:
              'opacity 1s cubic-bezier(0.16,1,0.3,1) 0.15s, transform 1s cubic-bezier(0.16,1,0.3,1) 0.15s',
          }}
        >
          <div data-component-id="src/app/components/InstitutionUpdates.tsx:241:10" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="241" data-component-end-line="353" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22glass-card%20rounded-3xl%20h-full%20border%20border-border%20overflow-hidden%20shadow-float%22%7D" className="glass-card rounded-3xl h-full border border-border overflow-hidden shadow-float">

            {/* Header */}

            <div data-component-id="src/app/components/InstitutionUpdates.tsx:245:12" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="245" data-component-end-line="269" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20px-7%20py-6%20border-b%20border-border%22%7D" className="flex items-center justify-between px-7 py-6 border-b border-border">

              <div data-component-id="src/app/components/InstitutionUpdates.tsx:247:14" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="247" data-component-end-line="257" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">

                <p data-component-id="src/app/components/InstitutionUpdates.tsx:249:16" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="249" data-component-end-line="251" data-component-file="InstitutionUpdates.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20font-semibold%20text-foreground%22%2C%22textContent%22%3A%22Latest%20Updates%22%7D" className="text-lg font-semibold text-foreground">
                  Latest Updates
                </p>

                <p data-component-id="src/app/components/InstitutionUpdates.tsx:253:16" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="253" data-component-end-line="255" data-component-file="InstitutionUpdates.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%20mt-1%22%2C%22textContent%22%3A%22News%2C%20Notices%20%26%20Circulars%22%7D" className="text-sm text-muted-foreground mt-1">
                  News, Notices & Circulars
                </p>

              </div>

               <div data-component-id="src/app/components/InstitutionUpdates.tsx:259:15" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="259" data-component-end-line="267" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-11%20h-11%20rounded-2xl%20bg-secondary%2F10%20flex%20items-center%20justify-center%22%7D" className="w-11 h-11 rounded-2xl bg-secondary/10 flex items-center justify-center">

                <Icon data-component-id="src/app/components/InstitutionUpdates.tsx:261:16" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="261" data-component-end-line="265" data-component-file="InstitutionUpdates.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22BellAlertIcon%22%2C%22className%22%3A%22text-secondary%22%7D"
                  name="BellAlertIcon"
                  size={20}
                  className="text-secondary"
                />

              </div> 

            </div>

            {/* Scrollable Updates */}

            <div data-component-id="src/app/components/InstitutionUpdates.tsx:273:12" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="273" data-component-end-line="331" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-h-%5B620px%5D%20overflow-y-auto%20custom-scrollbar%22%7D" className="max-h-[620px] overflow-y-auto custom-scrollbar">

              {updates.map((item) => (

                <Link data-component-id="src/app/components/InstitutionUpdates.tsx:277:16" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="277" data-component-end-line="327" data-component-file="InstitutionUpdates.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fnews%22%2C%22className%22%3A%22group%20block%20px-7%20py-6%20border-b%20border-border%20transition-all%20duration-300%20hover%3Abg-secondary%2F5%22%7D"
                  href="/news"
                  key={item.id}
                  className="group block px-7 py-6 border-b border-border transition-all duration-300 hover:bg-secondary/5"
                >

                  <div data-component-id="src/app/components/InstitutionUpdates.tsx:283:18" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="283" data-component-end-line="325" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20gap-4%22%7D" className="flex items-start gap-4">

                    {/* Icon */}

                    {/*<div className="w-12 h-12 rounded-2xl bg-secondary/10 flex items-center justify-center shrink-0 transition-all duration-300 group-hover:bg-secondary group-hover:text-white">

                      <Icon
                        name={item.icon as any}
                        size={20}
                        className="text-secondary group-hover:text-white"
                      />

                    </div> */}

                    {/* Content */}

                    <div data-component-id="src/app/components/InstitutionUpdates.tsx:299:20" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="299" data-component-end-line="323" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%22%7D" className="flex-1">

                      <div data-component-id="src/app/components/InstitutionUpdates.tsx:301:22" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="301" data-component-end-line="315" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20mb-3%22%7D" className="flex items-center justify-between mb-3">

                        <span data-component-id="src/app/components/InstitutionUpdates.tsx:303:24" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="303" data-component-end-line="307" data-component-file="InstitutionUpdates.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22inline-flex%20items-center%20rounded-full%20bg-muted%20px-3%20py-1%20text-%5B11px%5D%20font-semibold%20uppercase%20tracking-wide%20text-muted-foreground%22%7D" className="inline-flex items-center rounded-full bg-muted px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">

                          {item.type}

                        </span>

                        <span data-component-id="src/app/components/InstitutionUpdates.tsx:309:24" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="309" data-component-end-line="313" data-component-file="InstitutionUpdates.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xs%20text-muted-foreground%22%7D" className="text-xs text-muted-foreground">

                          {item.date}

                        </span>

                      </div>

                      <h4 data-component-id="src/app/components/InstitutionUpdates.tsx:317:22" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="317" data-component-end-line="321" data-component-file="InstitutionUpdates.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22font-semibold%20text-%5B17px%5D%20leading-7%20text-foreground%20transition-colors%20duration-300%20group-hover%3Atext-primary%22%7D" className="font-semibold text-[17px] leading-7 text-foreground transition-colors duration-300 group-hover:text-primary">

                        {item.title}

                      </h4>

                    </div>

                  </div>

                </Link>

              ))}

            </div>

            {/* Footer */}

            <div data-component-id="src/app/components/InstitutionUpdates.tsx:335:12" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="335" data-component-end-line="351" data-component-file="InstitutionUpdates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22px-7%20py-6%20bg-muted%2F20%22%7D" className="px-7 py-6 bg-muted/20">

              <Link data-component-id="src/app/components/InstitutionUpdates.tsx:337:14" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="337" data-component-end-line="349" data-component-file="InstitutionUpdates.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fnews%22%2C%22className%22%3A%22btn-outline%20w-full%20justify-center%22%2C%22textContent%22%3A%22View%20All%20Updates%22%7D"
                href="/news"
                className="btn-outline w-full justify-center"
              >

                View All Updates

                <Icon data-component-id="src/app/components/InstitutionUpdates.tsx:344:16" data-component-path="src/app/components/InstitutionUpdates.tsx" data-component-line="344" data-component-end-line="347" data-component-file="InstitutionUpdates.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowRightIcon%22%7D"
                  name="ArrowRightIcon"
                  size={16}
                />

              </Link>

            </div>

          </div>
        </div>

      </div>

      {/* Bottom Stats */}

      {/*<div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16">

        <div className="glass-card rounded-2xl p-6 text-center">

          <p className="stat-number">150+</p>

          <p className="text-xs text-muted-foreground mt-2">
            News Published
          </p>

        </div>

        <div className="glass-card rounded-2xl p-6 text-center">

          <p className="stat-number">35+</p>

          <p className="text-xs text-muted-foreground mt-2">
            Academic Circulars
          </p>

        </div>

        <div className="glass-card rounded-2xl p-6 text-center">

          <p className="stat-number">120+</p>

          <p className="text-xs text-muted-foreground mt-2">
            Campus Events
          </p>

        </div>

        <div className="glass-card rounded-2xl p-6 text-center">

          <p className="stat-number">100%</p>

          <p className="text-xs text-muted-foreground mt-2">
            Student Updates
          </p>

        </div>

      </div> */}

    </section>
  );
}